export const keyPress = {
  ENTER: 13,
  ESCAPE: 27,
  BACKSPACE: 8,
  DELETE: 46,
  BACKSLASH: 191,
};
